export function formatExchangeRate(
  rate: number,
  locale = 'en-US',
  {
    minimumFractionDigits = 2,
    maximumFractionDigits = 5,
  }: Intl.NumberFormatOptions = {},
) {
  const formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return formatter.format(rate);
}
